<template>
	<div class="meter-water-manage-container">
		<el-row :gutter="20">
			<el-col :span="24">
				<el-card shadow="never" class="search-card">
					<div slot="header" class="card-header">
						<span>查询条件</span>
					</div>
					<div class="flex justify-start">
						<el-form :inline="true" :model="queryParams">
							<el-form-item>
								<el-input v-model="queryParams.user_name" placeholder="请输入表编号" clearable
									style="width: 800px" />
							</el-form-item>
							<!-- <el-form-item>
								<el-select v-model="queryParams.project_code" placeholder="项目编号" style="width: 240px">
									<el-option label="日钢机械" value="日钢机械" />
									<el-option label="日钢机械B栋" value="日钢机械B栋" />
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-select v-model="queryParams.gate" placeholder="阀门状态" style="width: 240px">
									<el-option label="合闸" value="合闸" />
									<el-option label="跳闸" value="跳闸" />
								</el-select>
							</el-form-item> -->
							<el-form-item>
								<el-button type="primary" @click="handleSearch">搜索</el-button>
								<el-button @click="handleReset">重置</el-button>
								<el-button @click="handleExport">导出</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-card>

				<el-card shadow="never" class="table-card">
					<div slot="header" class="card-header">
						<span>智能水电表</span>
					</div>
					<el-table :data="list" v-loading="loading" border stripe>
						<el-table-column type="index" label="序号" width="50" />
						<el-table-column prop="deviceId" label="用户编号" width="150" align="center" />
						<el-table-column label="类型规格" width="90" align="center">
							<template slot-scope="{ row }">
								<el-tag>{{ getDeviceType(row.tableType) }}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="user_name" label="用户姓名" width="150" />
						<el-table-column prop="tableNo" label="表编号" width="150" />
						<el-table-column prop="netStatus" width="150" label="设备当前状态">
							<template slot-scope="{ row }">
								<span :style="{color: row.netStatus === '在线' ? 'green': 'red'}">{{row.netStatus}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="gate" label="阀门状态" width="80" align="center">
							<template slot-scope="{ row }">
								<img v-if="row.gate == '合闸'" style="height: 32px;width: 32px"
									src="/img/meter/ele_open.png">
								<img v-else style="height: 32px;width: 32px" src="/img/meter/ele_close.png">
							</template>
						</el-table-column>
						<el-table-column label="当前读数" width="100" align="center">
							<template slot-scope="{ row }">
								<span style="color: #409EFF;">{{row.reading || '-'}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="readTime" label="读表时间" width="170" />
						<el-table-column prop="project_code" label="项目编码" />
						<el-table-column prop="tableAddress" width="120" label="表地址" />
						<el-table-column prop="onlineAt" width="160" label="最近上线时间" />
						<el-table-column prop="house_number" label="门牌号" width="120" />
						<el-table-column label="操作" width="220" fixed="right" align="center">
							<template slot-scope="{ row }">
								<!-- <el-button size="small" type="text" @click="handleDetail(row)">详情</el-button>
                <el-button size="small" type="text" @click="handleEdit(row)">修改</el-button>
                <el-button size="small" type="text" style="color: #f56c6c" @click="handleDelete(row)">删除</el-button> -->
								<el-button size="small" type="text" @click="handleClean(row)"><i
										class="el-icon-stopwatch"></i>清零</el-button>
								<el-button v-if="!row.gate || row.gate == '合闸'" size="small" type="text"
									@click="handleControlSwitch(row, '1')"><i class="el-icon-unlock"></i>跳闸</el-button>
								<el-button v-if="row.gate == '跳闸'" size="small" type="text"
									@click="handleControlSwitch(row, '2')"><i class="el-icon-lock"></i>合闸</el-button>
								<el-button size="small" type="text" @click="handleRecord(row)"><i
										class="el-icon-tickets"></i>记录</el-button>
								<el-button size="small" type="text" @click="handleCharge(row)"><i
										class="el-icon-wallet"></i>充值</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination :current-page="queryParams.pageNo" :page-size="queryParams.pageSize" :total="total"
						:page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
						@size-change="handleSizeChange" @current-change="handlePageChange"
						class="pagination-container" />
				</el-card>
			</el-col>
		</el-row>
		<CleanMeterMachine :visible.sync="cleanVisible" :clean-data="currentRow" @success="handleSuccess" />
		<ChargeMeter :visible.sync="chargeVisible" :charge-data="currentRow" @success="handleSuccess" />
		<ReadDetailMeter :visible.sync="readVisible" :charge-data="currentRow" @success="handleSuccess">
		</ReadDetailMeter>
	</div>
</template>

<script>
	import meterRequest from '@/api/meter/meterRequest';
	import ChargeMeter from '@/components/meter/ChargeMeter.vue';
	import CleanMeterMachine from '@/components/meter/CleanMeterMachine.vue';
	import ReadDetailMeter from '@/components/meter/ReadDetailMeter';
	import { getDeviceType, exportExcel } from '@/api/meter/common';
	export default {
		name: 'MeterMachineManage',
		components: {
			ChargeMeter,
			CleanMeterMachine,
			ReadDetailMeter
		},
		data() {
			return {
				loading: false,
				list: [],
				total: 0,
				meterTypes: [],
				factorys: [],
				delVisible: false,
				cleanVisible: false,
				readVisible: false,
				customReadVisible: false,
				chargeVisible: false,
				currentRow: null,
				queryParams: {
					pageNo: 1,
					pageSize: 30,
					tableNo: undefined,

				},
				readMeterList: [],
				meterAllList: []
			}
		},
		mounted() {
			this.getAllList()
			this.getreadMeter()
			// this.fetchList()
		},
		methods: {
			getDeviceType,
			_getMeterTypeName(meterType) {
				const item = this.meterTypes.find(t => t.typeId === meterType)
				return item ? item.typeName : '-'
			},
			async getAllList() {
				const res = await meterRequest.post('/meter/meterList', {
					pageNo: 1,
					pageSize: 1000
				});
				if (res.code == 200) {
					this.meterAllList = res.data
					localStorage.setItem('METER_LIST', JSON.stringify(res.data))
				}
			},
			async getreadMeter() {
				const res = await meterRequest.post('/meter/readMeter');
				if (res.code == 200) {
					this.readMeterList = res.data
					this.fetchList()
				}
			},
			async fetchList() {
				this.loading = true
				// 构建 Map
				const meterMap = new Map(this.readMeterList.map(item => [item.deviceId, item]));
				// 需要拷贝的字段
				const fields = ['reading', 'readTime'];
				try {
					const res = await meterRequest.post('/meter/meterList', this.queryParams);
					if (res.code == 200) {
						this.list = res.data.map(b => {
							const a = meterMap.get(b.deviceId);
							if (a) {
								const merged = {
									...b
								};
								fields.forEach(f => {
									merged[f] = a[f];
								});
								return merged;
							}
							return b; // 未匹配到则保持原样
						})
						this.total = res.totalCount || 0
					}
				} finally {
					this.loading = false
				}
			},
			searchList() {
				this.loading = true
				// 构建 Map
				const meterMap = new Map(this.readMeterList.map(item => [item.deviceId, item]));
				// 需要拷贝的字段
				const fields = ['reading', 'readTime'];
				this.list = this.meterAllList.filter(item => {
					if(item.user_name == this.queryParams.user_name) {
						const a = meterMap.get(item.deviceId);
						if (a) {
							const merged = {
								...item
							};
							fields.forEach(f => {
								merged[f] = a[f];
							});
							return merged;
						}
						return item;
					}
					return item.user_name == this.queryParams.user_name;
				})
				this.total = this.list.length
				this.loading = false
			},
			handleSearch() {
				this.queryParams.pageNo = 1
				this.searchList()
				// this.fetchList()
			},
			handleReset() {
				this.queryParams = {
					pageNo: 1,
					pageSize: 30,
					tableNo: undefined
				}
				this.fetchList()
			},
			handleClean(row) {
				this.currentRow = {
					...row
				}
				this.cleanVisible = true
			},
			handleCharge(row) {
				this.currentRow = {
					...row
				}
				this.chargeVisible = true
			},
			handleRecord(row) {
				this.currentRow = {
					...row
				}
				this.readVisible = true
			},
			handleCustomRead() {
				this.customReadVisible = true
			},
			handleSettingRead() {
				this.settingVisible = true
			},
			async handleControlSwitch(row, controlType) {
				const data = {
					deviceId: row.deviceId,
					type: controlType
				}
				try {
					await this.$confirm(`确定要${controlType == '合闸' ? '跳闸' : '合闸'}该设备吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
				} catch {
					return
				}
				try {
					const res = await meterRequest.post('/meter/meterInstruct', data);
					if (res.code == 200) {
						this.$message.success(controlType == '合闸' ? '跳闸成功' : '合闸成功')
						this.fetchList()
					}
				} catch (e) {
					this.$message.error(e.msg || '操作失败')
				}
			},
			handleSuccess() {
				this.fetchList()
			},
			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchList()
			},
			handlePageChange(val) {
				this.queryParams.pageNo = val
				this.fetchList()
			},
			//导出数据
			async handleExport() {
				// 构建 Map
				const meterMap = new Map(this.readMeterList.map(item => [item.deviceId, item]));
				// 需要拷贝的字段
				const fields = ['reading', 'readTime'];
				const data = this.meterAllList.map(b => {
					const a = meterMap.get(b.deviceId);
					if (a) {
						const merged = {
							...b
						};
						fields.forEach(f => {
							merged[f] = a[f];
						});
						return merged;
					}
					return b;
				})
				
				await exportExcel({
					fileName: '户表管理',
					sheetName: '户表',
					data: data,
					onProgress: (p) => console.log(p.stage, p.message),
				});
			}
		}
	}
</script>

<style scoped lang="scss">
	.meter-water-manage-container {
		padding: 20px;

		.tree-container {
			min-height: 450px;
			overflow-y: auto;
			background: #fff;
			padding: 10px;
			border-radius: 4px;
		}

		.margin-top {
			margin-top: 20px;
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}

		.clearfix:after {
			clear: both;
		}
	}

	.search-card {
		margin-bottom: 16px;
	}

	.table-card {
		margin-bottom: 0;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-container {
		margin-top: 16px;
		text-align: right;
	}

	.type-tree-card {
		background: #fff;
		border-radius: 4px;
		padding: 8px 0;
	}

	.type-list {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.type-item {
		padding: 10px 16px;
		cursor: pointer;
		border-radius: 4px;
		margin: 0 8px 5px;
		text-align: center;
		font-size: 14px;
		color: #303133;
		transition: all 0.3s;
	}

	.type-item:hover {
		background-color: #f5f7fa;
	}

	.type-item-active {
		background-color: #00c2b2;
		color: white;
		font-weight: bold;
	}
</style>